
import ShowFileUploadWin from "./components/showFileUploadWin";
import ShowFormWin from "./components/showFormWin";
import ShowAclWin from "./components/showAclWin";
import ShowTreeWin from "./components/showTreeWin";
import ShowGridWin from "../../jsCom/go-dialog/components/showGridWin";
import ShowLeftTreeRightGrid from "../../jsCom/go-dialog/components/showLeftTreeRightGrid";
import {QueryCommand,Dataset} from "goingutils";

let goDialog = {
    //将选择的用户信息保存到数据库 作为最近使用人信息
    saveInfoRecentUsers(params) {
        //设置loading提示为false
        let queryCommand = new QueryCommand({url:''});
        let submitJson = {
            dataset: new Dataset(params)
        };
        queryCommand.executeQuery(submitJson);
    },
    //显示附件上传win窗口
    showFileUploadWin(options) {
        //激活树
        let goCompDialog = new ShowFileUploadWin(options);
        //弹出窗口
        goCompDialog.showWin(options);
    },
    //激活相应的form对象
    attachForm(options, vueObj) {
        let goCompDialog = new ShowFormWin(options);
        return goCompDialog.showWin(options, vueObj);
    },
    //销毁授权窗口
    destructionAcl() {
        if (this.aclDialog != null) {
            this.aclDialog.destruction();
        }
        this.aclDialog = null;
    },
    //弹出授权窗口
    attachAclWin(options, vueObj) {
        //激活树
        let goCompDialog = new ShowAclWin(options);
        this.aclDialog = goCompDialog.showWin(vueObj);
    },
    //  弹出带树的窗口
    attachTree(options) {
        //激活树
        let goCompDialog = new ShowTreeWin(options);
        goCompDialog.showWin();
    },
    //  弹出带表格的窗口
    attachGrid(options, vueObj) {
        let goCompDialog = new ShowGridWin(options);
        goCompDialog.showWin(vueObj);
    },
    //激活一个左树右单表界面
    attachLeftTreeRightGrid(options, vueObj) {
        let goCompDialog = new ShowLeftTreeRightGrid(options, vueObj);
        goCompDialog.showWin();
    },
    //激活服务选择窗口
    attachControlWin(options,vueObj) {
        let winConfig = {
            colOrderNum: true,
            colSelBox: false,
            fieldAry: [
                {
                    id: "name",
                    query: true,
                    type: "ro",
                    sorting: "str",
                    align: "left",
                    label: "服务名称",
                    width: "90"
                },
                {
                    id: "url",
                    query: true,
                    type: "ro",
                    sorting: "str",
                    align: "left",
                    label: "服务地址",
                    width: "*"
                },
                {
                    id: "method",
                    query: true,
                    type: "ro",
                    sorting: "str",
                    align: "left",
                    label: "提交方式",
                    width: "*"
                },
                {
                    id: "remark",
                    query: true,
                    type: "ro",
                    sorting: "str",
                    align: "left",
                    label: "备注",
                    width: "*"
                }
            ]
        };
        //接收传递的参数
        winConfig["treeUrl"]=options["treeUrl"];
        winConfig["queryUrl"]=options["queryUrl"];
        winConfig["clickTreeNode"]=options["clickTreeNode"];
        let defOpt={
            height: 550,
            width: 850,
            title: "选择相应的服务",
            hasSearch: true,
            hasTreeSearch:true,
            config: winConfig,
            //确定按钮
            confirmBtn(mygrid, vueObj, treeObj) {
                options.confirmBtn({mygrid, vueObj, treeObj});
            }
        };
        $.extend(defOpt,options);
        //激活一个左树右表的界面
        goDialog.attachLeftTreeRightGrid(defOpt,vueObj);
    }
};
export default goDialog;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/go-dialog/index.js